import { api } from 'api';
import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import AdditionalInformation from 'components/FormAddTransaction/components/AdditionalInformation/ver2';
import CancelAddTransactionPopup from 'components/FormAddTransaction/components/CancelAddTransactionPopup';
import PaymentMethod from 'components/FormAddTransaction/components/PaymentMethod/ver2/index';
import ReceiverPayoutMethod from 'components/FormAddTransaction/components/ReceiverPayoutMethod/ver3';
import Remittance from 'components/FormAddTransaction/components/Remittance/ver2';
import { fetchReceiverRecordInformation } from 'components/FormAddTransaction/func';
import { fetchReceiverInformation } from 'components/Receivers/func';
import { getLookupFeeAmountLatest } from 'components/Transactions/func';
import CollapseSidebarProcessStepsLayout from 'components/common/CollapseSidebarProcessStepsLayout';
import InformPopup from 'components/common/InformPopup';
import {
  ADD_TRANSACTION_MESSAGE_NAME,
  ADD_TRANSACTION_METHOD_BANK_NAME,
  ADD_TRANSACTION_METHOD_EWALLET_NAME,
  ADD_TRANSACTION_METHOD_PICKUP_NAME,
  ADD_TRANSACTION_OCCUPATION_NAME,
  ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  ADD_TRANSACTION_PAYOUT_METHOD_NAME,
  ADD_TRANSACTION_PREVIOUS_EMPLOYED_NAME,
  ADD_TRANSACTION_PURPOSE_NAME,
  ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME,
  ADD_TRANSACTION_RECEIVER_GET_NAME,
  ADD_TRANSACTION_RECEIVER_NAME,
  ADD_TRANSACTION_RELATIONSHIP_NAME,
  ADD_TRANSACTION_SOURCE_NAME,
  ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME,
  ADD_TRANSACTION_YOU_SEND_NAME,
  DESKTOP_MIN_WIDTH,
  METHOD_BANK,
  METHOD_EPAYMENT,
  METHOD_EWALLET,
  METHOD_HOME,
  METHOD_PAYTO,
  METHOD_PICKUP,
  PAYMENT_CREADIT_CARD_NO,
  PAYMENT_CREADIT_CARD_TYPE,
  RESET_ADD_TRANSACTION_INFORMATION_STORE,
  STATUS_CANCELLED,
  STATUS_FAIL,
  STATUS_SUBMITTED,
  STATUS_SUCCESS,
  TRANSACTIONS_PREFIX,
} from 'constants';
import useCalculatorRoundingStore from 'features/calculatorRounding/hooks/useCalculatorRoundingStore';
import withShowPIIVerifyNowModal from 'features/pii/HOCs/withShowPIIVerifyNowModal';
import Cookies from 'helpers/cookies';
import { checkMaintenance } from 'helpers/maintenance';
import useClarity from 'hooks/clarity/useClarity';
import { DiscountLoadingProvider } from 'hooks/discount-loading/DiscountLoadingContext';
import useAddTransaction, {
  ADD_TRANSACTION_TOTAL_NUMBER_OF_STEPS,
  MAKE_PAYMENT_KEY,
} from 'hooks/form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import ServiceAlerts from 'hooks/service-alerts';
import useServiceAlertsConfig from 'hooks/service-alerts/useServiceAlertsConfig';
import useServiceAlertsStore from 'hooks/service-alerts/useServiceAlertsStore';
import useAuth from 'hooks/useAuth';
import useCountryConfig from 'hooks/useCountryConfig';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import usePreventBrowserBackButton from 'hooks/usePreventBrowserBackButton';
import useQuery from 'hooks/useQuery';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  SET_ADD_TRANSACTION_CURRENT_STEP,
  SET_ADD_TRANSACTION_INFORMATION,
  SET_CURRENT_RECEIVER,
  SET_SHOW_LOADING,
  SET_SHOW_PENDING,
  SET_TOKEN_TRANSACTION,
} from 'store/action';
import styled from 'styled-components';
import { numberUtils, objectUtils } from 'utils';

const AddTransactionPage = withShowPIIVerifyNowModal(() => {
  const { t } = useLang();
  const {
    dispatch,
    resetAddTransactionInformation,
    currentReceiver,
    addTransactionInformation,
    tokenTransaction,
    addTransactionCurrentStep: currentStep,
    setTransactionDetails,
  } = useFormAddTransactionStore();
  const { remittance } = addTransactionInformation || {};
  const { isAddAnotherReceivingCurrency } = remittance || {};
  const navigate = useNavigate();
  const { token, isAuthenticated } = useAuth();
  const { getNavbarsAndBodyContentOfSidebar } = useAddTransaction();
  const { isAddTransactionPage } = usePage();

  // Backing into the abandoned send-money flow must land on the transactions list,
  // the destination this page's own exit already uses (see navigate() below).
  usePreventBrowserBackButton(TRANSACTIONS_PREFIX);

  const countryConfig = useRef();
  countryConfig.current = useCountryConfig('', countryConfig.current);

  const [isOpenCancelPopup, setOpenCancelPopup] = useState(false);
  const [isOpenInformPopup, setOpenInformPopup] = useState(false);
  const [isOpenBackPopup, setOpenBackPopup] = useState(false);

  const query = useQuery();
  const rid = query.get('rid');
  const refNumber = query.get('refNumber');
  const paymentStatus = query.get('paymentStatus');
  const isMakePayment = Cookies.get(MAKE_PAYMENT_KEY) || refNumber;
  const isDisabled =
    paymentStatus === STATUS_FAIL ||
    paymentStatus === STATUS_CANCELLED ||
    isMakePayment;

  const isForceHideDiscountEligibilityToast = useRef(false);

  const { clarityAPI } = useClarity();
  useEffect(() => {
    clarityAPI.init();
  }, [isAuthenticated]);

  const { setServiceAlertsByCountryCode, setServiceAlertsByPayments } =
    useServiceAlertsStore();
  const { setCalculatorRoundingResponse } = useCalculatorRoundingStore();
  const { countryCode } = useServiceAlertsConfig();
  const renderServiceAlerts = () => {
    if (countryCode) return <ServiceAlerts />;
    return null;
  };

  const paymentMintProcess = async (token, refNumber, tokenTransaction) => {
    const homeUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    const successPath = `${homeUrl}/tran?refNumber=${refNumber}&paymentStatus=${STATUS_SUCCESS}`;
    const failPath = `${homeUrl}/tran?refNumber=${refNumber}&paymentStatus=${STATUS_FAIL}`;

    try {
      const { data } = await api.processMint(
        token,
        refNumber,
        tokenTransaction,
      );

      if (data) {
        const { success } = data;

        dispatch({ type: SET_TOKEN_TRANSACTION, payload: '' });

        dispatch({ type: SET_SHOW_PENDING, payload: false });

        if (success) {
          window.location.href = successPath;
        } else {
          window.location.href = failPath;
        }
      }
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);

      dispatch({ type: SET_TOKEN_TRANSACTION, payload: '' });

      dispatch({ type: SET_SHOW_PENDING, payload: false });

      window.location.href = failPath;
    }
  };

  const getTransactionInformationInitial = async (
    token,
    currentReceiver,
    refNumber,
  ) => {
    let informationStore = { ...addTransactionInformation };

    try {
      if (!currentReceiver) {
        const { data: dataOccupation } = await api.getOccupation(token);

        const { data } = await api.getTran(token, refNumber);

        if (!isEmpty(data)) {
          // DEV-1385-04: a `paymentStatus=success` URL (the promoted URL
          // DEV-1385-03 mints for PayID/Deposit/PayTo) is validated here too,
          // not exempted — `!paymentStatus` alone would let a stale success
          // URL through regardless of the transaction's current server-side
          // state. `paymentStatus=fail`/`paymentStatus=cancelled` keep the
          // old exemption unchanged: those are handled by the isDisabled/
          // step-3 popup path elsewhere in this file, not by this guard.
          //
          // EPAYMENT is excluded from the new validation: `paymentMintProcess`
          // above already mints a `paymentStatus=success` URL for EPAYMENT
          // today, and DEV-1385-04's own packet is explicit that this
          // pre-existing mint/EPAYMENT success screen carries no live pay-me
          // instructions, so it was never the exposure this guard is closing.
          // A card-settled transaction is also not reliably STATUS_SUBMITTED
          // by the time this runs, so without this exclusion a first,
          // legitimate arrival at the EPAYMENT success URL gets misread as a
          // stale revisit and bounced to /transactions.
          const isPaymentStatusExemptOrSuccess =
            !paymentStatus ||
            (paymentStatus === STATUS_SUCCESS &&
              data?.paymentMethod !== METHOD_EPAYMENT);
          const isPreventMakePaymentWhenDirectlyAccessURLOfAProcessedTxn =
            isMakePayment &&
            refNumber &&
            isPaymentStatusExemptOrSuccess &&
            (data?.status !== STATUS_SUBMITTED ||
              (data?.paymentMethod === METHOD_PAYTO &&
                !data?.allowMakePayment));
          if (isPreventMakePaymentWhenDirectlyAccessURLOfAProcessedTxn) {
            if (!token) return;
            if (!refNumber || (paymentStatus && paymentStatus !== STATUS_SUCCESS))
              return;
            handleOnClickCancelPopup();
            return;
          } else {
            setTransactionDetails(data);
          }
        }

        if (!isEmpty(data) && !isEmpty(dataOccupation)) {
          const {
            payout,
            fee,
            remittance,
            relationship,
            purpose,
            source,
            message,
            paymentMethod,
            creaditCardNo,
            creaditCardType,
            discount,
            discountDetails,
          } = data;

          await fetchReceiverRecordInformation(token, refNumber);

          informationStore = {
            ...informationStore,
            receiverPayoutMethod: {
              [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: payout?.dmCode,
            },
            remittance: {
              [ADD_TRANSACTION_YOU_SEND_NAME]: Number(
                remittance[0].sendAmount || 0,
              ),
              [ADD_TRANSACTION_RECEIVER_GET_NAME]: Number(
                remittance[0].receiveAmount || 0,
              ),
              [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: Number(
                remittance[1]?.sendAmount || 0,
              ),
              [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: Number(
                remittance[1]?.receiveAmount || 0,
              ),
              isAddAnotherReceivingCurrency: remittance.length === 2,
              currentCurrencySelected: {
                countryCode: remittance[0]?.currency?.countryCode,
                dmCode: payout?.dmCode,
                currencyCode: remittance[0]?.currency?.code,
              },
              rate: remittance[0]?.rate,
              currentRateStore: remittance[0]?.rate,
              remittanceId: remittance[0]?.id,
              currentCurrencySelectedAnother: remittance[1]?.currency
                ? {
                    countryCode: remittance[1]?.currency?.countryCode,
                    dmCode: payout?.dmCode,
                    currencyCode: remittance[1]?.currency?.code,
                  }
                : null,
              rateAnother: remittance[1] ? remittance[1]?.rate : null,
              currentRateAnotherStore: remittance[1]
                ? remittance[1]?.rate
                : null,
              remittanceAnotherId: remittance[1]?.id,
              feeAmount: fee || null,
            },
            additionalInformation: {
              [ADD_TRANSACTION_RELATIONSHIP_NAME]:
                objectUtils.convertToKeyValue(relationship),
              [ADD_TRANSACTION_OCCUPATION_NAME]: objectUtils.convertToKeyValue(
                dataOccupation.job,
              ),
              [ADD_TRANSACTION_PREVIOUS_EMPLOYED_NAME]:
                objectUtils.convertToKeyValue(dataOccupation?.previousJob),
              [ADD_TRANSACTION_PURPOSE_NAME]:
                objectUtils.convertToKeyValue(purpose),
              [ADD_TRANSACTION_SOURCE_NAME]:
                objectUtils.convertToKeyValue(source),
              [ADD_TRANSACTION_MESSAGE_NAME]: message,
            },
            paymentMethod: {
              [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: paymentMethod,
              [PAYMENT_CREADIT_CARD_NO]: creaditCardNo?.slice(-4),
              [PAYMENT_CREADIT_CARD_TYPE]: creaditCardType,
              paymentMethodTxn: paymentMethod,
              discountsAvailable: [],
              discountsInactive: [],
              discountApplied: discount || null,
              discountDetails: discount ? discountDetails : null,
            },
          };

          if (payout?.dmCode === METHOD_PICKUP) {
            informationStore = {
              ...informationStore,
              receiverPayoutMethod: {
                [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: payout?.dmCode,
                [ADD_TRANSACTION_METHOD_PICKUP_NAME]: payout?.pickupOffice,
              },
            };
          }

          if (payout?.dmCode === METHOD_BANK) {
            informationStore = {
              ...informationStore,
              receiverPayoutMethod: {
                [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: payout?.dmCode,
                [ADD_TRANSACTION_METHOD_BANK_NAME]: payout?.bank,
              },
            };
          }

          if (payout?.dmCode === METHOD_EWALLET) {
            informationStore = {
              ...informationStore,
              receiverPayoutMethod: {
                [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: payout?.dmCode,
                [ADD_TRANSACTION_METHOD_EWALLET_NAME]: payout?.ewallet,
              },
            };
          }
        }
      } else {
        const dmCode =
          informationStore.receiverPayoutMethod[
            ADD_TRANSACTION_PAYOUT_METHOD_NAME
          ];

        const sendAmount = numberUtils.mathRound(
          informationStore.remittance[ADD_TRANSACTION_YOU_SEND_NAME] || 0,
        );
        const sendAnotherAmount = numberUtils.mathRound(
          informationStore.remittance[ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME] ||
            0,
        );
        const sendTotalAmount = numberUtils.mathRound(
          sendAmount + sendAnotherAmount,
        );

        if (dmCode === METHOD_HOME) {
          informationStore = {
            ...informationStore,
            receiverPayoutMethod: {
              ...informationStore.receiverPayoutMethod,
              [ADD_TRANSACTION_RECEIVER_NAME]: currentReceiver,
              currentPayoutItemSelectedIndex: 0,
            },
          };
        }

        if (dmCode === METHOD_PICKUP) {
          const itemId =
            informationStore.receiverPayoutMethod[
              ADD_TRANSACTION_METHOD_PICKUP_NAME
            ]?.pickUpOfficeId;

          informationStore = {
            ...informationStore,
            receiverPayoutMethod: {
              ...informationStore.receiverPayoutMethod,
              [ADD_TRANSACTION_RECEIVER_NAME]: currentReceiver,
              currentPayoutItemSelectedIndex: itemId,
            },
          };
        }

        if (dmCode === METHOD_BANK) {
          const itemId =
            informationStore.receiverPayoutMethod[
              ADD_TRANSACTION_METHOD_BANK_NAME
            ]?.id;

          informationStore = {
            ...informationStore,
            receiverPayoutMethod: {
              ...informationStore.receiverPayoutMethod,
              [ADD_TRANSACTION_RECEIVER_NAME]: currentReceiver,
              currentPayoutItemSelectedIndex: itemId,
            },
          };
        }

        if (dmCode === METHOD_EWALLET) {
          const itemId =
            informationStore.receiverPayoutMethod[
              ADD_TRANSACTION_METHOD_EWALLET_NAME
            ]?.id;

          informationStore = {
            ...informationStore,
            receiverPayoutMethod: {
              ...informationStore.receiverPayoutMethod,
              [ADD_TRANSACTION_RECEIVER_NAME]: currentReceiver,
              currentPayoutItemSelectedIndex: itemId,
            },
          };
        }

        if (!isDisabled && parseInt(sendTotalAmount)) {
          informationStore = {
            ...informationStore,
            remittance: await getLookupFeeAmountLatest({
              sendAmount: sendTotalAmount,
              dmCode,
              isOnlyCurrency: !isAddAnotherReceivingCurrency,
              information: { ...informationStore.remittance },
              countryCode: currentReceiver?.country?.code,
            }),
          };
        }
      }

      dispatch({
        type: SET_ADD_TRANSACTION_INFORMATION,
        payload: informationStore,
      });
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);
      handleOnClickCancelPopup();
    }
  };

  useEffect(() => {
    if (!currentReceiver && rid) {
      fetchReceiverInformation(token, rid);
    }
  }, [currentReceiver, query, token]);

  useEffect(() => {
    if (refNumber) {
      // DEV-1434: `getTransactionInformationInitial` runs its already-completed
      // → redirect eligibility check (above, `isPreventMakePaymentWhenDirectlyAccessURLOfAProcessedTxn`)
      // asynchronously, while `currentStep` is (for `isMakePayment`) advanced to
      // 3 synchronously below in this same tick — mounting the interactive
      // `PaymentMethod` step immediately. Without a gate, a fast Pay click (or a
      // slow network response) could reach payment submission before the
      // redirect resolves for an already-completed transaction. Piggyback on the
      // app's existing global `SET_SHOW_LOADING` overlay (`Layout`/`LoadingScreen`,
      // also used by `FormForgotPassword`, `withCheckBSBNumber`, etc.) to block
      // interaction with the whole page — including the Pay button — for exactly
      // the isMakePayment window this async check is in flight. `.finally()`
      // clears it whether the check redirects, confirms the transaction is
      // payable, or throws (the function's own try/catch already swallows
      // errors via `handleOnClickCancelPopup`, so this promise always resolves
      // and the overlay can never hang open).
      if (isMakePayment) {
        dispatch({ type: SET_SHOW_LOADING, payload: true });
      }

      const eligibilityCheck = getTransactionInformationInitial(
        token,
        currentReceiver,
        refNumber,
      );

      if (isMakePayment) {
        eligibilityCheck.finally(() => {
          dispatch({ type: SET_SHOW_LOADING, payload: false });
        });
      }
    }

    let currentStep = 0;

    if (isMakePayment) {
      currentStep = 3;

      if (paymentStatus === STATUS_CANCELLED) {
        currentStep = 3;

        setOpenInformPopup(true);

        dispatch({
          type: SET_ADD_TRANSACTION_CURRENT_STEP,
          payload: currentStep,
        });

        return;
      }

      if (paymentStatus === STATUS_FAIL) {
        currentStep = 3;

        setOpenInformPopup(true);

        dispatch({
          type: SET_ADD_TRANSACTION_CURRENT_STEP,
          payload: currentStep,
        });
      }

      if (paymentStatus === STATUS_SUCCESS) {
        Cookies.remove(MAKE_PAYMENT_KEY);

        currentStep = 4;

        dispatch({
          type: SET_ADD_TRANSACTION_CURRENT_STEP,
          payload: currentStep,
        });

        return;
      }

      if (!refNumber && !currentReceiver) {
        Cookies.remove(MAKE_PAYMENT_KEY);

        window.location.reload();
      }

      dispatch({
        type: SET_ADD_TRANSACTION_CURRENT_STEP,
        payload: currentStep,
      });

      return;
    }

    if (paymentStatus === STATUS_CANCELLED) {
      currentStep = 3;

      setOpenInformPopup(true);

      dispatch({
        type: SET_ADD_TRANSACTION_CURRENT_STEP,
        payload: currentStep,
      });

      return;
    }

    if (paymentStatus === STATUS_FAIL) {
      currentStep = 3;

      setOpenInformPopup(true);

      dispatch({
        type: SET_ADD_TRANSACTION_CURRENT_STEP,
        payload: currentStep,
      });
    }

    if (paymentStatus === STATUS_SUCCESS) {
      Cookies.remove(MAKE_PAYMENT_KEY);

      currentStep = 4;

      dispatch({
        type: SET_ADD_TRANSACTION_CURRENT_STEP,
        payload: currentStep,
      });

      return;
    }
  }, [currentReceiver, query, token, isMakePayment]);

  useEffect(() => {
    if (tokenTransaction && refNumber) {
      dispatch({ type: SET_SHOW_PENDING, payload: true });

      paymentMintProcess(token, refNumber, tokenTransaction);
    }
  }, [tokenTransaction, query]);

  useEffect(() => {
    return () => {
      if (!isAddTransactionPage) {
        console.log(`⭐ AddTransactionPage 👉 useEffect ➡️ cleanup ↩`);
        dispatch({
          type: SET_ADD_TRANSACTION_INFORMATION,
          payload: RESET_ADD_TRANSACTION_INFORMATION_STORE,
        });
        dispatch({
          type: SET_CURRENT_RECEIVER,
          payload: null,
        });
        dispatch({
          type: SET_ADD_TRANSACTION_CURRENT_STEP,
          payload: 0,
        });
        Cookies.remove(MAKE_PAYMENT_KEY);
        // UNREACHABLE — the comment below describes an intention this code does
        // not deliver. `isAddTransactionPage` is captured from the render that
        // registered this cleanup, and this page only commits a render while the
        // route is the add-transaction route, so the `!isAddTransactionPage`
        // guard above is never satisfied and nothing in this block runs. Pinned
        // by `flowExitCleanup.test.jsx` beside this file (DEV-1385 ticket 2).
        //
        // Two consequences for anyone reading this as prior art. It is NOT
        // evidence that quote invalidation already exists — see
        // `features/calculatorRounding/func/quoteLifecycle.js`, which is where
        // that decision now lives. And `setCalculatorRoundingResponse()` with no
        // argument is the wholesale reset, which also nulls `fee`, `originalFee`
        // and `remittance`; a zeroed fee misclassifies flat-fee discounts as
        // inactive, so it is the wrong tool for invalidating a spent quote.
        //
        // Removing or reviving this is deliberately out of scope: the block also
        // governs state that mid-transfer receiver excursions depend on, and a
        // naive revival destroys an in-progress transfer.
        //
        // Original intent, retained verbatim:
        // Clear the quote-dedup cache on any flow exit (back/nav/route change,
        // not just Cancel) so re-entering the same amount in a new flow always
        // re-fetches /quote. Only fires when leaving the add-transaction page,
        // so step navigation within the flow keeps its cached quote.
        setCalculatorRoundingResponse();
      }
    };
  }, [isAddTransactionPage]);

  // BEG-DEV1385-04-C-refined-01: closes DEV-1385-04's warm-in-session-arrival gap.
  // The direct-access guard above (`getTransactionInformationInitial`) only runs
  // inside `if (!currentReceiver)`, so a `currentReceiver` that survives a route
  // change and back reaches a stale `paymentStatus=success` URL without the guard
  // running at all. This effect clears it on unmount — deliberately NOT by
  // widening the dead effect above (that one also resets
  // `addTransactionInformation`, the step, and the payment cookie, which would
  // discard in-progress flow state on a brief receiver excursion; this effect
  // clears only `currentReceiver`).
  //
  // Deps are `[]`, with no `!isAddTransactionPage` guard — unlike the effect
  // above. With an empty dependency array a cleanup fires exactly once, at the
  // component's actual unmount, so there is no dependency-change case to
  // distinguish it from; a guard here would face the same closure-staleness
  // problem documented on the effect above (the value read would still be
  // whatever was true during this component's own renders, i.e. always `true`,
  // making `!isAddTransactionPage` always `false`) for no benefit, since the only
  // time this cleanup runs already **is** the unmount case.
  //
  // Confirmed this does not fire on the promotion's own `navigate`
  // (`PaymentMethod/ver2/index.jsx`, `DEV-1385-03`): that call changes only the
  // query string and does not unmount this component, so it can't trigger an
  // effect that only fires on unmount. Firing there would null `currentReceiver`
  // mid-page and force the re-running init effect into its cold branch,
  // duplicating the `api.getTran` call `DEV-1385-03`/`-04` already verify happens
  // at most once — the regression this scoping is specifically designed to avoid.
  //
  // A receiver excursion (`?rid=` — `AddReceiverPage/ver2:101`,
  // `withTriggerShowUpdateCompletedModal:49`, `ReceiverItem:27`) unmounts this
  // page, so this effect fires and clears `currentReceiver`; the excursion's
  // return already handles a null `currentReceiver` via `fetchReceiverInformation`
  // (`if (!currentReceiver && rid)` above) — one extra fetch, not a regression.
  useEffect(() => {
    return () => {
      dispatch({ type: SET_CURRENT_RECEIVER, payload: null });
    };
  }, []);

  const handleOnToggleCancelPopup = () => {
    if (isMakePayment) {
      handleOnToggleBackPopup();
      return;
    }

    setOpenCancelPopup(!isOpenCancelPopup);
  };

  const handleOnClickCancelPopup = () => {
    clarityAPI.stop();

    setOpenCancelPopup(false);

    Cookies.remove(MAKE_PAYMENT_KEY);

    resetAddTransactionInformation();

    // Clear the quote-dedup cache so a new flow re-fetches /quote even when the
    // same amount/receiver is re-entered. The signature persists on a global
    // store slice that resetAddTransactionInformation() does not touch.
    setCalculatorRoundingResponse();

    dispatch({ type: SET_CURRENT_RECEIVER, payload: null });

    dispatch({ type: SET_ADD_TRANSACTION_CURRENT_STEP, payload: 0 });

    setServiceAlertsByCountryCode(null);
    setServiceAlertsByPayments(null);

    navigate(`${TRANSACTIONS_PREFIX}`);
  };

  const handleOnToggleBackPopup = () => {
    setOpenBackPopup(!isOpenBackPopup);
  };

  const stepContentReference = {
    0: (
      <ReceiverPayoutMethod
        countryConfig={countryConfig.current}
        handleOnToggleCancelPopup={handleOnToggleCancelPopup}
        isDisabled={isDisabled}
        rid={rid}
        isForceHideDiscountEligibilityToast={
          isForceHideDiscountEligibilityToast
        }
      />
    ),
    1: (
      <Remittance
        // Remount to reset Step 2 to first-visit state: the system-error modal's
        // Close bumps step2ResetNonce, which re-initialises Remittance's local
        // state (amount/currency/etc.) that the store reset alone cannot clear.
        key={addTransactionInformation?.step2ResetNonce ?? 0}
        countryConfig={countryConfig.current}
        handleOnToggleCancelPopup={handleOnToggleCancelPopup}
        isDisabled={isDisabled}
        isForceHideDiscountEligibilityToast={
          isForceHideDiscountEligibilityToast
        }
      />
    ),
    2: (
      <AdditionalInformation
        countryConfig={countryConfig.current}
        handleOnToggleCancelPopup={handleOnToggleCancelPopup}
        isDisabled={isDisabled}
      />
    ),
    3: (
      <PaymentMethod
        countryConfig={countryConfig.current}
        handleOnToggleCancelPopup={handleOnToggleCancelPopup}
        isDisabled={isDisabled}
      />
    ),
    4: (
      <PaymentMethod
        countryConfig={countryConfig.current}
        handleOnToggleCancelPopup={handleOnToggleCancelPopup}
        isDisabled={isDisabled}
      />
    ),
  };

  return (
    <>
      {isOpenCancelPopup && (
        <CancelAddTransactionPopup
          isOpen={isOpenCancelPopup}
          onClose={handleOnToggleCancelPopup}
          onClick={handleOnClickCancelPopup}
        />
      )}
      {isOpenInformPopup && (
        <InformPopup
          isOpen={isOpenInformPopup}
          imageSrc={NoticeIcon}
          imagesStyles={{
            width: '75px',
            height: '60px',
            marginBottom: '16px',
          }}
          text={t('popup_payment_fail')}
          textStyle={{
            color: 'var(--ds-c-grey-dark)',
          }}
          content={t('popup_payment_fail_desc')}
          buttonLabel1={null}
          buttonLabel2={t('button_ok')}
          onClose={() => setOpenInformPopup(false)}
          onClick={() => setOpenInformPopup(false)}
          isBackdropOverlap={false}
        />
      )}
      {isOpenBackPopup && (
        <InformPopup
          isOpen={isOpenBackPopup}
          content={t('popup_confirm_back_transaction')}
          buttonLabel1={t('button_no')}
          buttonLabel2={t('button_yes')}
          onClose={handleOnToggleBackPopup}
          onClick={handleOnClickCancelPopup}
          isBackdropOverlap={false}
        />
      )}
      {currentStep <= ADD_TRANSACTION_TOTAL_NUMBER_OF_STEPS && (
        <DiscountLoadingProvider>
          <AddTransactionStyled
            data-testid="add-transaction-current-step"
            data-current-step={currentStep}
          >
            <CollapseSidebarProcessStepsLayout
              titleSidebar={t('add_transaction_send_money_label')}
              navbars={getNavbarsAndBodyContentOfSidebar()}
              currentStep={currentStep}
              stepContentReference={stepContentReference}
              isPreview={isDisabled}
              isSuccess={currentStep === 4}
            />
            {renderServiceAlerts()}
          </AddTransactionStyled>
        </DiscountLoadingProvider>
      )}
    </>
  );
});

const AddTransactionStyled = styled.div`
  margin: 70px 0px 0px 0px;
  padding: 16px;
  height: calc(100dvh - 70px);
  width: 100%;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin: unset;
    margin-top: 0px;
    padding: unset;
    padding-top: 96px;
    height: fit-content;
    min-height: 100dvh;
  }
`;

export default AddTransactionPage;
